import { ColorSwatch, Tooltip } from '@mantine/core';
import { FC, ReactElement, useMemo } from 'react';

import StatusDotType from '@/models/StatusDotType.ts';

interface Props {
    type: StatusDotType;
    text?: string;
    size?: number;
    color?: string;
}

const StatusDot: FC<Props> = ({ type, text, color, size = 8 }) => {
    const display_color = useMemo(() => {
        if (type === StatusDotType.GENERIC) {
            return color || 'gray';
        }

        // If custom color is provided, use it regardless of type
        if (color) return color;

        // If no type and no color, return default
        if (!type) return '#16a34a';

        // Otherwise use type-based colors
        switch (type) {
            case StatusDotType.GREEN: {
                return '#16a34a';
            }
            case StatusDotType.YELLOW: {
                return '#eab308';
            }
            case StatusDotType.RED: {
                return '#dc2626';
            }
            case StatusDotType.BLUE: {
                return '#2563eb';
            }
            default: {
                return '#16a34a';
            }
        }
    }, [type, color]);

    const renderStatus = (): ReactElement => (
        <div className="flex size-4 items-center justify-center">
            <ColorSwatch size={size} color={display_color} />
        </div>
    );

    if (text) {
        return <Tooltip label={text}>{renderStatus()}</Tooltip>;
    }
    return renderStatus();
};

export default StatusDot;
